export const apiGatewayURL =
    'https://6wejtf8b29.execute-api.us-east-1.amazonaws.com';
export const maxS3UploadRetries = 5;
